import { render, staticRenderFns } from "./StackedBarChart.vue?vue&type=template&id=67420eb6&"
import script from "./StackedBarChart.vue?vue&type=script&lang=js&"
export * from "./StackedBarChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports